export class MemberUpdateDetailsModel {
  firstName?: string;

  lastName?: string;

  dob?: string;

  gender?: string;

  edrFirstName?: string;

  edrLastName?: string;

  edrCardNo?: string;

  edrDob?: string;

  mailingUnitNumber?: string;

  mailingStreetNumber?: string;

  mailingStreetName?: string;

  mailingSuburb?: string;

  mailingState?: string;

  mailingPostcode?: string;

  preferredCommsEmail?: string;

  preferredCommsPhoneNumber?: string;

  isTeamOfferOptIn?: boolean;
}
